import { authHttp } from '../http'
import * as routes from '../../routes/picking.routes'
import { errorHandler } from '../../../util/error.service'
import { parseToMysqlFormat } from '../../../util/date.service'

export async function getResumoSeparacaoInfo(picking_id) {
  try {
    const response = await authHttp().get(routes.urlGetResumoSeparacaoInfo(picking_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function getResumoSeparacaoManualInfo(picking_id) {
  try {
    const response = await authHttp().get(routes.urlGetResumoSeparacaoManualInfo(picking_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function assocFaltaOcorrencia(associacao) {
  try {
    await authHttp().post(routes.urlPostAssocFaltaOcorrencia, associacao)
    return
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function assocSobraOcorrencia(associacao, selectedPicking) {
  try {
    await authHttp().post(routes.urlPostAssocSobraOcorrencia(selectedPicking), associacao)
    return
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function saveFaltasSeparacaoManual(faltas, picking_id) {
  try {
    const response = await authHttp().post(routes.urlPostFaltasSeparacaoManual(picking_id), faltas)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function saveSobrasSeparacaoManual(sobras, picking_id) {
  try {
    const response = await authHttp().post(routes.urlPostSobrasSeparacaoManual(picking_id), sobras)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function finalizarResumoSeparacao(
  picking_id,
  {
    nome_motorista,
    placa_veiculo,
    data_chegada,
    horario_chegada,
    codigo_lacre,
    temp_thermo_king,
    data_operacao,
    transfer_vehicle_lated,
    motivo_atraso_id,
    obs_resumo_separacao,
  },
) {
  try {
    const resumo_emitido_em = parseToMysqlFormat(new Date())
    await authHttp().post(routes.urlPostEmitirResumo(picking_id), {
      nome_motorista,
      placa_veiculo,
      data_chegada,
      horario_chegada,
      codigo_lacre,
      temp_thermo_king,
      resumo_emitido_em,
      data_operacao,
      transfer_vehicle_lated,
      motivo_atraso_id,
      obs_resumo_separacao,
    })
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postFotosFalta(selectedPicking, falta_id, files_path) {
  try {
    const { data } = await authHttp().post(routes.urlPostFotoFaltaPath(selectedPicking), {
      fotos: files_path,
      falta_id,
    })
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteMissingProductImage(selectedPicking, file_id) {
  try {
    await authHttp().delete(routes.urlDeleteMissingProductImage(selectedPicking, file_id))
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteMissingProductFile(filename) {
  try {
    await authHttp().delete(routes.urlDeleteFotoFalta(filename))
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postFotosSobra(selectedPicking, sobra_id, files_path) {
  try {
    const { data } = await authHttp().post(routes.urlPostFotoSobraPath(selectedPicking), {
      fotos: files_path,
      sobra_id,
    })
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteLeftOverImage(selectedPicking, file_id) {
  try {
    await authHttp().delete(routes.urlDeleteLeftoverImage(selectedPicking, file_id))
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteLeftOverFile(filename) {
  try {
    await authHttp().delete(routes.urlDeleteFotoSobra(filename))
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function desdobrarFalta(falta_id, missing_reason_id_original, desdobramentos) {
  try {
    await authHttp().post(routes.urlPostDesdobrarFalta, {
      falta_id,
      missing_reason_id_original,
      desdobramentos,
    })
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateMissingProductSeparacaoAdjustment({
  falta_id,
  missing_reason_id,
  qte_adjusted,
  adjust_justification,
}) {
  try {
    await authHttp().put(routes.urlPutMissingProductSeparacaoAdjustment, {
      falta_id,
      missing_reason_id,
      qte_adjusted,
      adjust_justification,
    })
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateLeftoverProductSeparacaoAdjustment({
  sobra_id,
  missing_reason_id,
  qte_adjusted,
  adjust_justification,
}) {
  try {
    await authHttp().put(routes.urlPutLeftoverProductSeparacaoAdjustment, {
      sobra_id,
      missing_reason_id,
      qte_adjusted,
      adjust_justification,
    })
  } catch (error) {
    throw errorHandler(error)
  }
}
